import styled from '../../../../_snowpack/pkg/styled-components.js';
export const Center = styled.div.withConfig({
  displayName: "styles__Center",
  componentId: "sc-1x8eaqa-0"
})(["flex:1 1 auto;display:flex;align-items:center;justify-content:center;padding:30px;"]);